"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/radio/style");
var _radio = _interopRequireDefault(require("antd/lib/radio"));
var _react = _interopRequireDefault(require("react"));
require("./TabsGroup.less");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TabsGroup = function TabsGroup(_ref) {
  var value = _ref.value,
    valueLabelPairs = _ref.valueLabelPairs,
    handleTabChange = _ref.handleTabChange;
  var radioButtons = valueLabelPairs.map(function (elem) {
    return /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
      key: elem.label,
      value: elem.value
    }, elem.label);
  });
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "tabs-group",
    type: "flex",
    id: "tabs"
  }, /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
    value: value,
    onChange: handleTabChange,
    size: "small"
  }, radioButtons));
};
var _default = TabsGroup;
exports.default = _default;